var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tree',{staticStyle:{"margin-top":"20px"},attrs:{"data":_vm.data,"props":_vm.defaultProps},on:{"node-click":_vm.handleNodeClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }